import FootprintFormShipping from "../../components/FootprintForm/FootprintFormShipping"
import Footer from '../../components/Footer/Footer'
import './FootprintPages.css'

const FootprintPageShipping = () => {

    return (
        <>
            <FootprintFormShipping />
            <Footer />

        </>
    )
}

export default FootprintPageShipping